import ActiveService from '@/service.active';

const INVOICE_ACCOUNTS_URI = '/api/invoiceaccounts';

class settingsService extends ActiveService{
  constructor(
    $injector,
    $auth,
    $translates
  ){
    'ngInject';

    super( $injector );
    this.$translates = $translates;
  }

  fetchAll() {
    return this.activeGet(INVOICE_ACCOUNTS_URI);
  }

  post(data) {
    return this.activePost(INVOICE_ACCOUNTS_URI, data)
      .then( () => this.notify.set(this.$translates.get('SETTINGS_CREATED_SUCCESS'), 'success'))
  }

  getApplicationData(){
    return this.activeGet( this.uri );
  }

  update(data) {
    return this.activePut( data.uri, data )
      .then( () => this.notify.set(this.$translates.get('SETTINGS_UPDATE_SUCCESS'), 'success'))
  }

  delete(data) {
    return this.activeDelete(data.uri)
      .then( () => this.notify.set(this.$translates.get('SETTINGS_DELETE_SUCCESS'), 'success'))
  }

}

export default settingsService;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/settings/settings.service.js
 **/